<template>
  <div
    class="flex w-full items-center justify-center py-3 px-6 bg-argus-christine-500 rounded-lg cursor-pointer"
    :style="primaryColor ? { backgroundColor: primaryColor } : {}"
    :class="[disabled || isLoading ? 'opacity-50 pointer-events-none' : 'cursor-pointer']"
  >
    <template v-if="label">
      <p class="text-sm sm:text-md" :class="textClass">
        {{ isLoading ? 'Loading...' : label }}
      </p>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>
<script>
import { getReadableTextClass } from '@/utils/color'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    primaryColor: {
      type: String,
      default: null,
    },
  },
  computed: {
    textClass() {
      return getReadableTextClass(this.primaryColor)
    },
  },
}
</script>
